import { useTranslation } from 'react-i18next';

const NyseStepThree = () => {
  const { t } = useTranslation(['contractModal']);
  return (
    <div className={'contracts-steps-body'}>
      <ol>
        <li>{t('contractModal:nyse_modal.data_not_guaranteed')}</li>
        <li>
          {t('contractModal:nyse_modal.permitted_use_not_furnish_market_data')}
        </li>
      </ol>
    </div>
  );
};

export default NyseStepThree;
